import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchPreloadedCandidatesStatsFailed,
  fetchPreloadedCandidatesStatsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* fetchPreloadedCandidateStats({ payload }) {
  const url = `${API_BASE_URL}/statistics/preloaded-candidates?applicationId=${payload}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchPreloadedCandidatesStatsSuccess(response?.raw || {}));
  } else {
    yield put(fetchPreloadedCandidatesStatsFailed(response.message));
  }
}

export function* getPreloadedStats() {
  yield takeEvery(
    ApplicantsActionTypes.FETCH_PRELOADED_STATS_START,
    fetchPreloadedCandidateStats
  );
}
